import React from 'react'

import { formatPercentage } from '@vend/utilities'
import { SaleTax } from '../../models/sale'

interface Props {
  tax: SaleTax
}

export const TaxRate: React.FC<Props> = ({ tax }) => {
  const displayRate = formatPercentage(tax.rate?.rate || 0)
  const contents = `${tax.name} (${displayRate})`

  return <span>{contents}</span>
}
